import { OptimizelyFeatureFlags } from 'constants/optimizely'
import { getOptimizelyFeatureFlagVariation } from 'lib/optimizely/optimizelyUtils'
import { createSelector } from 'reselect'
import { isSpoofed } from 'selectors/featuresSelectors'
import {
  isPassportCardStartDateWithinAllowedRange,
  PASSPORT_CARD_UTM_CAMPAIGN,
} from 'checkout/Components/CheckoutSteps/Review/PassportCardInsurance/passportCardUtils'
import getInsuranceDatesFromCart from './getInsuranceDatesFromCart'
import { hasPassportCardEligibleItems } from '../view/itemViews/getPassportCardQuoteItems'

const isPassportCardExclusiveCheckoutEnabled = createSelector(
  (state: App.State) => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.croPassportCardInsuranceOption),
  (state: App.State) => getOptimizelyFeatureFlagVariation(state, OptimizelyFeatureFlags.croPassportCardExclusiveCheckout),
  (state: App.State) => state.utm.campaign,
  (state: App.State) => state.geo.currentRegionCode,
  (state: App.State) => isSpoofed(state),
  (state: App.State) => getInsuranceDatesFromCart(state)?.startDate,
  (state: App.State) => hasPassportCardEligibleItems(state),
  (
    isPassportCardInsuranceOptionEnabled,
    isPassportCardExclusiveCheckoutFlagEnabled,
    utmCampaign,
    regionCode,
    spoofed,
    checkoutStartDate,
    cartHasEligibleItems,
  ): boolean => {
    if (!isPassportCardInsuranceOptionEnabled) return false
    if (!isPassportCardExclusiveCheckoutFlagEnabled) return false
    if (utmCampaign !== PASSPORT_CARD_UTM_CAMPAIGN) return false
    if (regionCode !== 'AU') return false
    if (spoofed) return false
    if (!isPassportCardStartDateWithinAllowedRange(checkoutStartDate)) return false
    return cartHasEligibleItems
  },
)

export default isPassportCardExclusiveCheckoutEnabled
